import { ITypeTicketData } from 'meta/pages/v4/typeticket'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  ids: number[]
}

type Response = { items: ITypeTicketData[] }

export const getBulkData = async (props: Props): Promise<Response> => {
  const { ids } = props

  const endpoint = ApiEndpoint.v4.typeticket.bulk(ids.map((x) => String(x)))

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
